import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base.service';
import { TipoPlazaModel } from '../../models/tipo-plaza.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoPlazaService extends BaseService<TipoPlazaModel>{

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Tipo plaza';
    this.urlBase = `${environment.baseApi}${environment.endPoints.maestras.base_maestra}${environment.endPoints.maestras.tipoPlaza}`;
   }
}
